import type { CashEntry, SalePaymentMethod } from "@artisancode/api-types";

export const SUMMARY_CARD_METHODS: SalePaymentMethod[] = [
  "cash",
  "edc",
  "qris",
];

export interface CashGroup {
  date: string;
  source: CashEntry["source"];
  label: string;
  total: number;
  breakdown: { method: CashEntry["method"]; amount: number }[];
  workspaceId: string;
}

export function groupCashEntries(items: CashEntry[]): CashGroup[] {
  const groups = new Map<string, CashGroup>();
  for (const item of items) {
    const key = `${item.date}|${item.source}|${item.label}|${item.workspaceId}`;
    const group = groups.get(key);
    if (group) {
      group.total += item.amount;
      const existingMethod = group.breakdown.find(
        (b) => b.method === item.method,
      );
      if (existingMethod) existingMethod.amount += item.amount;
      else group.breakdown.push({ method: item.method, amount: item.amount });
    } else {
      groups.set(key, {
        date: item.date,
        source: item.source,
        label: item.label,
        total: item.amount,
        breakdown: [{ method: item.method, amount: item.amount }],
        workspaceId: item.workspaceId,
      });
    }
  }
  return [...groups.values()];
}
